export const insaneTemplates = {
  projectiles5: {
    layout: `
.........BBBBBBBBBBBB.........
.........BBBBBBBBBBBB.........
.........BBBBBBBBBBBB.........
.........BBBBBBBBBBBB.........
.........BBBBBBBBBBBB.........
.........BBBBBBBBBBBB.........
.........BBBBBBBBBBBB.........
..BB......................pB..
..BB......................BB..
..BB......................BB..
..BB......................pB..
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },
  projectile_stair_up5: {
    layout: `
..BB.......................BBB
..BB.......................pBB
......................BBB..BBB
...........................BBB
.................BBB.......BBB
...........................BBB
..BB........BBB............BBB
..BB.......................pBB
.......BBB.................BBB
...........................BBB
BBBBB......................BBB
BBBBB......................BBB
`,
    metadata: {},
  },
  stair_down5: {
    layout: `
BBB...........................
..............................
..............................
..........S...................
..........BBB.................
..............................
..............................
....................S.........
....................BBB.......
.........................SS...
.........................BBBBB
.........................BBBBB
`,
    metadata: {},
  },
  spikes5: {
    layout: `
...SSSSSS...SSSSSS...SSSSSS...
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  // A dense laser timing gate (six beams) — the laser hazard insane was missing.
  lasers5: {
    layout: `
.....L...L...L...L...L...L....
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  // Solid step (+3) behind a three-spike gauntlet.
  step_up5: {
    layout: `
....................S.........
.................BBBBBBBBBBBBB
.................BBBBBBBBBBBBB
....S..S..S......BBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  // Tight platform climbs/descents (+6 / -6) with a spike on the stepping stone.
  raised_platform_up5: {
    layout: `
.......................BBBBBBB
.......................BBBBBBB
.............S.........BBBBBBB
..........BBBBBBBB.....BBBBBBB
.......................BBBBBBB
.......................BBBBBBB
BBBBB..................BBBBBBB
BBBBB..................BBBBBBB
`,
    metadata: {},
  },
  raised_platform_down5: {
    layout: `
BBBBBBB.......................
BBBBBBB.......................
BBBBBBB.........S.............
BBBBBBB....BBBBBBBB...........
BBBBBBB.......................
BBBBBBB.......................
BBBBBBB..................BBBBB
BBBBBBB..................BBBBB
`,
    metadata: {},
  },

  // Two-lane projectile gauntlets that change plane, with spikes on the floor
  // approach and the far ledge — the hardest dodging climbs/descents.
  projectile_up5: {
    layout: `
........................S.....
......................BBBBBBBB
..BB..........pB......BBBBBBBB
..BB....S.....pB......BBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },
  projectile_down5: {
    layout: `
....S.........................
BBBBBBBB......................
BBBBBBBB..............pB......
BBBBBBBB......S.......pB......
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  // The hardest ascent (+8): a tight 3-cell chimney with a laser beam strung
  // across it mid-climb. You can't just rush up — the beam pulses through the
  // one lane you climb in, so you grip the wall below it and launch on the gap.
  // A spike greets the run-in and another sits on the exit ledge to punish a
  // sloppy final wall-jump. Narrower than the lower-tier climbs (see the
  // wall-jump notes in easy_templates.js); contentTopRow is the exit ledge.
  wall_chimney5: {
    layout: `
..............BBB.............
..............BBB.............
..............BBB.........S...
..............BBB...BBBBBBBBBB
..............BBB...BBBBBBBBBB
..............BBB...BBBBBBBBBB
..............BBB.L.BBBBBBBBBB
..............BBB...BBBBBBBBBB
..............BBB...BBBBBBBBBB
..............BBB...BBBBBBBBBB
......S.............BBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: { contentTopRow: 10 },
  },

  // wall_chimney_bullets5 (+9): the tight 3-cell chimney with two turrets on the
  // front wall sweeping the climb lane — you can't pause on a wall, the rounds
  // cross the whole gap. Each turret has the front mass as its right-hand mount
  // and the back wall as its left-hand backstop. See easy_templates.js.
  wall_chimney_bullets5: {
    layout: `
..............BBB.............
..............BBB.............
..............BBB.............
..............BBB...BBBBBBBBBB
..............BBB...BBBBBBBBBB
..............BBB..pBBBBBBBBBB
..............BBB...BBBBBBBBBB
..............BBB...BBBBBBBBBB
..............BBB..pBBBBBBBBBB
..............BBB...BBBBBBBBBB
..............BBB...BBBBBBBBBB
....................BBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: { contentTopRow: 10 },
  },

  // wall_descent_laser5 (-8): the deepest descent — ride the wall down past a
  // vertical laser beam in the shaft, and thread the landing between a spike in
  // the shaft floor and another past the doorway. Slow, deliberate sliding is
  // the only way through. See wall_descent3 for the shape.
  wall_descent_laser5: {
    layout: `
..............BBB.............
..............BBB.............
..............BBB.............
..............BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB..L.BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB.S......S...........
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: { contentTopRow: 9 },
  },
};
